import * as React from 'react';
import BasicContentSection from '../basic-content-section/BasicContentSection';

const Keynotes = ({ section }) => {
  return <BasicContentSection section={section} />;
};

export default Keynotes;
